import { useEffect } from 'react';
import { initControlsOnce } from '@atlassian/jira-browser-storage-controls/src/utils/init-once/index.tsx';

export const BrowserStorageControlsInit = () => {
	useEffect(() => {
		initControlsOnce();
	}, []);

	return null;
};
